define(['jquery', 'core/ajax', 'core/notification', 'sweetalert2', 'core/url', 'core/str'],
function($, ajax, notification, Swal, moodleurl, str) {
    var index = {
        dom: {
            main: null
        },
        langs: {
            beforeExpireNotification: null,
            pleaseSubscribeNotification: null,
            clickHereToPayment: null,
            pleaseSubscribe: null,
        },
        action: {
            getString: function(renewpopup, subscriptionexpiry) {
                str.get_strings([
                    {key: 'beforeexpirenotification', component: 'local_custom_auth'},
                    {key: 'pleasesubscribenotification', component: 'local_custom_auth'},
                    {key: 'clickheretopayment', component: 'local_custom_auth'},
                    {key: 'pleasesubscribe', component: 'local_custom_auth'},
                ]).then(function(s) {
                    index.langs.beforeExpireNotification = s[0];
                    index.langs.pleaseSubscribeNotification = s[1];
                    index.langs.clickHereToPayment = s[2];
                    index.langs.pleaseSubscribe = s[3];
                    index.init(renewpopup, subscriptionexpiry);
                }).fail(function(e) {});
            },
        },
        init: function(renewpopup, subscriptionexpiry) {
            if (renewpopup == 1) {
                if (subscriptionexpiry > 0) {
                    Swal.fire("Subscription expiring soon!",
                    index.langs.beforeExpireNotification + subscriptionexpiry + " days</b>. " +
                        index.langs.pleaseSubscribe +
                        "<a href='"+moodleurl.relativeUrl('/local/custom_auth/userrenewalsubscription.php') + "'>" +
                        index.langs.clickHereToPayment,
                        "warning"
                        );
                } else {
                    Swal.fire("Subscription expired!", index.langs.pleaseSubscribeNotification, "warning");
                }
            }
        }
    };
    return {
        init: index.action.getString
    };
});